import { KYMW9010Component } from "./kymw9010.component";
    
/** ユーザ情報詳細画面の値を管理するクラス
 *
 * @export KYMW9010Model
 * @class KYMW9010Model
 */
export class KYMW9010Model {

  kymw9010Component: KYMW9010Component;

  /**
   * 関連会社区分(1:制作会社、2:スタジオ)
   */
  public associatedCompanyType: string = <string>'';
  /**
   * 関連会社ID
   */
  public associatedCompanyId: string = <string>'';
  /**
   * 関連会社名(漢字)
   */
  public associatedCompanyName: string = <string>'';
  /**
   * 取引停止区分名
   */
  public tradeStopDivName: string = <string>'';

  /**
   * 関連会社ユーザ情報リスト
   */
  public associatedCompanyList: Array<any> = new Array();

  /**
   * 関連会社ユーザ情報の結果を取得
   * @param serverData 
   */
  public updateAssociatedCompanyList(serverData: any) {
    if ( serverData !== null) {
      let associatedCompanyInfo: any;
      const tempCompanyList = new Array();
      for (let i = Number(0); i < serverData.AssociatedCompanyList.length; i++) {
        associatedCompanyInfo = [];
        associatedCompanyInfo.associatedCompanyId = serverData.AssociatedCompanyList[i].AssociatedCompanyId;
        associatedCompanyInfo.associatedCompanyName = serverData.AssociatedCompanyList[i].AssociatedCompanyName;
        associatedCompanyInfo.tradeStopDivName = serverData.AssociatedCompanyList[i].TradeStopDivName;
        tempCompanyList.push(associatedCompanyInfo);
      }
      this.associatedCompanyList = tempCompanyList;
    }
  }
}